import React, { useState, useEffect } from 'react'
import { useField } from 'formik'
import ProductCollectionsApiV2 from 'api/v2/admins/product-collections-api-v2'
import ReactAsyncMultiselectField from 'components/molecules/react-async-multiselect-field'
import PropTypes from 'prop-types'

const propTypes = {
  label       : PropTypes.string,
  placeholder : PropTypes.string,
  required    : PropTypes.bool,
  isMultiple  : PropTypes.bool
}

const defaultProps = {
  label       : '',
  placeholder : '',
  required    : false,
  isMultiple  : true
}

/**
 * Allow multi select options for product collections.
 * Only to be used within a Formik component
 * @param {string} label - Field label
 * @param {string} placeholder - Field placeholder
 * @param {bool} required - Required badge will show if it set true
 * @param {bool} isMultiple - Choose if will select multiple collection or not
 */
const ProductCollectionAsyncMultiselectField = ({
  label,
  placeholder,
  required,
  isMultiple,
  ...props
}) => {

  const [ inputValue, setInputValue ]     = useState('')
  const [ dataSelected, setDataSelected ] = useState([])

  // * Do this to get helper object from useField
  // eslint-disable-next-line no-unused-vars
  const [ field, meta, helper ] = useField(props)

  useEffect(() => {
    if (!field.value) return
    let currentValue  = field.value.toString()
    let splittedValue = []

    if (currentValue !== '') {
      splittedValue = currentValue.split(',')
      ProductCollectionsApiV2.getCollections('', splittedValue)
        .then((response) => {
          const collectionOptions = response.data.collection

          setDataSelected([ ...dataSelected, ...collectionOptions ])

        })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const loadOptions = async () => {
    if (isMultiple === false && dataSelected.length === 1){
      alert('Maaf, Anda sudah memilih product collection sebelumnya. Silahkan ulangi lagi memilih.')

      setDataSelected([])
    }
    else {
      let result = await ProductCollectionsApiV2.getCollections(inputValue)
        .then((response) => response.data.collection)

      return result
    }
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    option.name
  )

  const handleCustomChange = (options) => {
    // * prevent undefined value
    if (options) {

      // * set specific value to the formikBag.values
      const optionValue = options.map((options) => options.id)
      const joinValue   = optionValue.join(',')
      helper.setValue(joinValue)
    }
    else {
      // * we should keep update the formik value
      // * If user remove all options, we update to empty array
      helper.setValue('')
    }
    setDataSelected(options)
  }

  return (
    <ReactAsyncMultiselectField
      name={ field.name }
      label={ label }
      placeholder={ placeholder }
      required={ required }
      isMultiple={ isMultiple }
      loadOptions={ loadOptions }
      getOptionLabel={ getOptionLabel }
      setInputValue={ setInputValue }
      handleCustomChange={ handleCustomChange }
      dataSelected={ dataSelected }
      { ...props }
    />
  )
}

ProductCollectionAsyncMultiselectField.propTypes    = propTypes
ProductCollectionAsyncMultiselectField.defaultProps = defaultProps

export default ProductCollectionAsyncMultiselectField
